import { callPostApi } from './apiCallerProxy';

const configPrefix = accountId => `/${accountId}/configurations`;

const configApi = {
    getConfigByAccountId: (accountId, requestPayload) => callPostApi(`${configPrefix(accountId)}/`, requestPayload),
};

export default configApi;
